import type { TRuleWithTheme } from '@/styles/theme';

export const largeInput: TRuleWithTheme = ({ theme }) => ({
    '&.ant-input': {
        fontWeight: '700',

        height: 'unset',

        min768: {
            ...theme.typography.Headline1,
            lineHeight: 1,
            paddingBlock: 0,
        },
    },
});

export const largeFormItem: TRuleWithTheme = () => ({
    width: '100%',
});

export const fieldAndFaviconContainer: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',

    gap: '0.62rem',
});
